import axios from "axios";

export const downloadFactoryInventoryReport = async (inputs) => {
    if (inputs.kc_fabric_code === undefined) {
        inputs.kc_fabric_code = "";
    }
    if (inputs.order_no === undefined) {
        inputs.order_no = "";
    }


    try {
        const config = {
            withCredentials: true,
            headers: {
                withCredentials: true,
            },
        };
        const data = await axios.get(
            `${process.env.REACT_APP_URL}/api/inventory/list/factory-inventory-download-excel?order_item_kc_fabric_code=${inputs.kc_fabric_code}&order_no=${inputs.order_no}`,
            config
        );
        return data?.data?.result;
    } catch (error) {
        console.log(error);
        return error?.response?.data?.result;
    }
};
